module.exports = __webpack_public_path__ + "static/media/common.6c6c507f.png";